import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    bgLayer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        transition: 'opacity 2.0s linear',
        willChange: 'opacity',
    },
    visible: {
        opacity: 1,
        zIndex: 1,
    },
    hidden: {
        opacity: 0,
        zIndex: 1,
    },
}));

const BackgroundImageCarousel = () => {

    const classes = useStyles();
    const transitionDuration = 2000;
    const slideDuration = 10000;

    const images = useMemo(() => [
        'Wallpaper1',
        'Wallpaper2',
        'Wallpaper3',
        'Wallpaper4',
        'Wallpaper5',
        'Wallpaper6',
        'Wallpaper7',
    ].map(name => `https://game-juridico.s3.sa-east-1.amazonaws.com/assets/wallpapers/${name}.png`), []);

    const [layer1Index, setlayer1Index] = useState(0);
    const [layer2Index, setlayer2Index] = useState(1);

    const [layer1Style, setlayer1Style] = useState(classes.visible)
    const [layer2Style, setlayer2Style] = useState(classes.hidden)

    const [updateLayer1, setUpdateLayer1] = useState(true)

    const [currentIndex, setCurrentIndex] = useState(1)

    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, [images]);

    useEffect(() => {
        const interval = setInterval(() => {
            setlayer1Style((l1s) => l1s === classes.visible ? classes.hidden : classes.visible)
            setlayer2Style((l2s) => l2s === classes.hidden ? classes.visible : classes.hidden)
            setTimeout(() => {
                setUpdateLayer1(ul1 => !ul1)
                setlayer1Index(updateLayer1 ? (currentIndex + 1) % images.length : layer1Index)
                setlayer2Index(!updateLayer1 ? (currentIndex + 1) % images.length : layer2Index)
                setCurrentIndex(cur => (cur + 1) % images.length)
            }, slideDuration - transitionDuration);

        }, slideDuration);

        return () => clearInterval(interval);
    });

    const foregroundStyle = {
        backgroundImage: `url(${images[layer1Index]})`,
    };
    const backgroundStyle = {
        backgroundImage: `url(${images[layer2Index]})`,
    };

    return (
        <div className={classes.root}>
            <div
                className={`${classes.bgLayer} ${layer1Style}`}
                style={foregroundStyle}
            />
            <div
                className={`${classes.bgLayer} ${layer2Style} `}
                style={backgroundStyle}
            />
        </div>
    );
};

export default BackgroundImageCarousel;
